"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const spinners = {
  large: {
    width: 48,
    height: 48,
    "> *": {
      cx: "50%",
      cy: "50%",
      r: 22,
      fill: "transparent",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeDasharray: 144,
      strokeDashoffset: 72
    }
  },
  medium: {
    width: 40,
    height: 40,
    "> *": {
      cx: "50%",
      cy: "50%",
      r: 18,
      fill: "transparent",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeDasharray: 120,
      strokeDashoffset: 60
    }
  },
  small: {
    width: 32,
    height: 32,
    "> *": {
      cx: "50%",
      cy: "50%",
      r: 14,
      fill: "transparent",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeDasharray: 96,
      strokeDashoffset: 48
    }
  },
  xsmall: {
    width: 24,
    height: 24,
    "> *": {
      cx: "50%",
      cy: "50%",
      r: 10,
      fill: "transparent",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeDasharray: 72,
      strokeDashoffset: 36
    }
  },
  xxsmall: {
    width: 16,
    height: 16,
    "> *": {
      cx: "50%",
      cy: "50%",
      r: 6,
      fill: "transparent",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeDasharray: 48,
      strokeDashoffset: 24
    }
  }
};

exports.default = spinners;